import _ from 'lodash';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { env } from '~/commons/config';
import { faUser as faRegUser } from '@fortawesome/free-regular-svg-icons/faUser';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faClock } from '@fortawesome/free-regular-svg-icons/faClock';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faBox } from '@fortawesome/free-solid-svg-icons/faBox';

const Nav = () => {
  const roles = _.get(env, 'user.roles');
  const isCus = _.isEqual(roles, ['customer']);
  const name = env?.user?.name?.full?.en;
  const links = _.compact([
    {
      to: '/portal/user',
      icon: faRegUser,
      label: 'User',
    },
    {
      to: '/portal/stocks',
      icon: faBox,
      label: 'Stocks',
    },
    !isCus && {
      to: '/portal/shareStocks',
      icon: faClock,
      label: 'Share History',
    },
    {
      href: '/logout',
      icon: faPowerOff,
      label: 'Logout',
      required: true,
    },
  ]);
  return (
    <nav className="col main-nav bg-light pr-0 py-5">
      <div
        className="nav pl-3 text-primary flex-column text-wrap text-break"
        style={{ fontSize: 24 }}>
        TAIPING
      </div>
      {name && (
        <NavLink
          className="nav pl-3 ml-3 pr-1 my-2 text-primary flex-column text-wrap text-break" style={{ width: '200px' }}
          to="/portal/user">
          Welcome: {_.startCase(name)}
        </NavLink>
      )}
      <div className="nav flex-column pl-3">
        {_.map(links, ({ to, icon, label, ...props }, i) => {
          const Link = to ? NavLink : (p) => <a {...p} />;
          return (
            <Link
              key={i}
              className="nav-link w-100 my-2 py-1"
              to={to}
              {...(to ? { activeClassName: 'active' } : {})}
              {...props}
            >
              <span className="mr-3">
                <FA icon={icon} fixedWidth size="lg" />
              </span>
              {label}
            </Link>
          )
        })}
      </div>
    </nav>
  );
}

export {
  Nav,
};
